module.exports = __webpack_public_path__ + "static/media/phone_icon.c3e6f857.svg";